import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState } from "../appState/models";
import { ManageBulkProcessState } from "./model";

export const manageBulkProcessSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.manageBulkProcess.manageBulkProcess,
);

// Selector for selected bulk process
export const selectedBulkProcessSelector = createDraftSafeSelector(
  manageBulkProcessSelector,
  (state: ManageBulkProcessState) => state.selectedBulkProcess,
);
